import axiosInstance from "../axios_instance";

export async function createCalendarYear(body) {
  try {
    return await axiosInstance.post(`calendarYears/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateCalendarYear(body, id) {
  try {
    return await axiosInstance.put(`calendarYears/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteCalendarYear(id) {
  try {
    const obj = { requestedAccess: 'Edit' }
    return await axiosInstance.delete(`calendarYears/${id}`, obj);
  } catch (error) {
    return error;
  }
}

export async function getAllCalendarYears() {
  try {
    return await axiosInstance.get(`calendarYears/`);
  } catch (error) {
    return error;
  }
}

export async function createEvent(body) {
  try {
    return await axiosInstance.post(`events/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateEvent(body, id) {
  try {
    return await axiosInstance.put(`events/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteEvent(id) {
  try {
    const obj = { requestedAccess: 'Edit' }
    return await axiosInstance.delete(`events/${id}`, obj);
  } catch (error) {
    return error;
  }
}

export async function getAllEvents(body) {
  try {
    return await axiosInstance.post(`events/get`, body);
  } catch (error) {
    return error;
  }
}
